module.exports = __webpack_public_path__ + "static/img/1_18_1.83f14e2b.jpg";